import { NON_STOP, ONE_STOP, TWO_STOPS } from './defines';
import { getDaysFromToday } from './functions';

export const getFindItinerariesSuccessStates = (itineraries, state, from, to) => {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const showSidebar = vw <= 575 ? false : true;
    const options = itineraries['options'];
    const schedules = itineraries['schedules'];
    let currentOptions = [];
    let stopFilter = NON_STOP;
    if (options[NON_STOP].length > 0) {
        currentOptions = options[NON_STOP];
    } else if (options[ONE_STOP].length > 0) {
        currentOptions = options[ONE_STOP];
        stopFilter = ONE_STOP;
    } else if (options[TWO_STOPS].length > 0) {
        currentOptions = options[TWO_STOPS];
        stopFilter = TWO_STOPS;
    }

    const selectedOptionIdx = 0;
    let filteredSchedules, currentSchedules, scheduleDay;
    [filteredSchedules, currentSchedules, scheduleDay] = getCurrentSchedules(currentOptions[selectedOptionIdx], schedules, state.scheduleDay);
    const routePrice = getRoutePrice(from, to, state.routePrices);

    return { ...state, loading: false, options, schedules, stopFilter, currentOptions, showSidebar, selectedOptionIdx, filteredSchedules, currentSchedules, scheduleDay, segments: [], routePrice };
}

export const getSelectItineraryOptionStates = (idx, state) => {
    let filteredSchedules, currentSchedules, scheduleDay;
    [filteredSchedules, currentSchedules, scheduleDay] = getCurrentSchedules(state.currentOptions[idx], state.schedules, state.scheduleDay);

    return { ...state, filteredSchedules, currentSchedules, scheduleDay, selectedOptionIdx: idx };
}

export const getChangeScheduleDayStates = (day, state) => {
    if (state.filteredSchedules[day] === undefined) {
        return state;
    }

    const currentSchedules = state.filteredSchedules[day];
    
    return { ...state, currentSchedules, scheduleDay: day };
}

export const getChangeStopOptionState = (stopOption, state) => {
    const stopFilter = stopOption;
    const currentOptions = state.options[stopOption];
    const selectedOptionIdx = 0;
    let filteredSchedules, currentSchedules, scheduleDay;
    [filteredSchedules, currentSchedules, scheduleDay] = getCurrentSchedules(currentOptions[selectedOptionIdx], state.schedules, state.scheduleDay);

    return { ...state, filteredSchedules, currentSchedules, currentOptions, scheduleDay, selectedOptionIdx, stopFilter };
}

export const getFindAllRoutesSuccessState = (data, state) => {
    return { ...state, to: '', options:[], currentOptions:[], selectedOptionIdx: 0, schedules: [], filteredSchedules: [], currentSchedules: [], loading: false, showSidebar:false, segments:data };
}

const getCurrentSchedules = (currentOption, schedules, scheduleDay) => {
    const selectedRouteKey = currentOption.key;
    const days = getDaysFromToday();
    let currentSchedules = [];
    let filteredSchedules = [];
    let currentCheck = false;
    for(const d in days) {
        if (schedules[days[d]] === undefined) {
            continue;
        }

        for(const i in schedules[days[d]]) {
            if (schedules[days[d]][i].key == selectedRouteKey) {
                if (!filteredSchedules[days[d]]) {
                    filteredSchedules[days[d]] = [schedules[days[d]][i]];
                } else {
                    filteredSchedules[days[d]].push(schedules[days[d]][i]);
                }
                
                if (!currentCheck) {
                    currentSchedules.push(schedules[days[d]][i]);
                } 
            }
        }

        if (currentSchedules.length > 0 && !currentCheck) {
            scheduleDay = days[d];
            currentCheck = true;
        }
        
    }

    return [filteredSchedules, currentSchedules, scheduleDay];
}

export const getShowRoutePriceState = (from, to, state) => {
    const routePrice = getRoutePrice(from, to, state.routePrices);

    return { ...state, routePrice }
}

export const getRoutePrice = (from, to, routePrices) => {
    const rpKey = from + '-' + to;
    if (rpKey in routePrices) {
        return { from, to, price: routePrices[rpKey] }
    }

    return {from: '', to: to, price:''}
}
